import { getMarketplaceBackend } from '../../config/pathURL/config';
import { rejectIfNotOk } from '../api';
import { postRequest } from '../requests';

export interface CreateOrderData {
    productId: string;
    assetIds: string[];
    externalReference: string;
    level: string;
    orderInfo: string;
}

export function createOrder({
    assetIds,
    productId,
    level,
    externalReference,
    orderInfo,
}: CreateOrderData): Promise<void> {
    const requestBody = {
        booking_requests: [
            {
                product_id: productId,
                level: level,
                resources: assetIds.map(assetId => ({
                    resource_id: assetId,
                    resource_type: 'asset',
                })),
                order: {
                    external_reference: externalReference,
                    info: orderInfo,
                },
            },
        ],
    };
    return fetch(`${getMarketplaceBackend()}/bookings`, postRequest(requestBody)).then(rejectIfNotOk);
}
